import createDOMPurify from 'dompurify';
const purify = createDOMPurify();

export function sanitizeHtml(htmlString: string) {
  if (htmlString) {
    return purify.sanitize(htmlString)
  }
  return ''
}
